import { render, staticRenderFns } from "./AssetCustomFieldsList.vue?vue&type=template&id=404b0ff7&scoped=true&"
import script from "./AssetCustomFieldsList.vue?vue&type=script&lang=js&"
export * from "./AssetCustomFieldsList.vue?vue&type=script&lang=js&"
import style0 from "./AssetCustomFieldsList.vue?vue&type=style&index=0&id=404b0ff7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404b0ff7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('404b0ff7')) {
      api.createRecord('404b0ff7', component.options)
    } else {
      api.reload('404b0ff7', component.options)
    }
    module.hot.accept("./AssetCustomFieldsList.vue?vue&type=template&id=404b0ff7&scoped=true&", function () {
      api.rerender('404b0ff7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/BookingFields/components/AssetCustomFieldsList.vue"
export default component.exports